import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px",
    "flex": "1 0 0"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_date_value = _resolveComponent("date-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  const _component_table_with_title = _resolveComponent("table-with-title");
  return _openBlock(), _createBlock(_component_table_with_title, {
    title: "Evolution",
    class: "performance-period-table",
    noDownload: "",
    fields: $options.fields,
    loading: $props.loading
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector")]),
    default: _withCtx(() => [_createVNode(_component_wrap_table_with_show_more, {
      modelValue: $options.period_pager,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.period_pager = $event),
      period: _ctx.period
    }, {
      default: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: "lite-table lite-table-hoverable period-table performance-table",
        fields: $options.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": true,
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        "no-border-collapse": "",
        onRowClicked: $options.handleRowClick
      }, {
        "thead-top": _withCtx(() => [_createVNode(_component_b_tr, {
          class: "headers"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            colspan: "1",
            style: {
              borderRight: 'none'
            }
          }), _createVNode(_component_b_th, {
            colspan: "1",
            "sticky-column": ""
          }), _createVNode(_component_b_th, {
            colspan: "1",
            "sticky-column": ""
          }), _createVNode(_component_b_th, {
            colspan: "6",
            style: {
              color: '#9447FF',
              borderBottom: '1px solid #9447FF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Seller performance")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "3",
            style: {
              color: '#2172E1',
              borderBottom: '1px solid #2172E1'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Seller market share")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          id: `default-period-table-${col?.column}`,
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `default-period-table-${col?.column}`
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_1)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["id", "styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(seller_notoriety)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.seller_notoriety,
              min: $options.minMax?.seller_notoriety?.min,
              color: "#FFA8BD",
              max: $options.minMax?.seller_notoriety?.max,
              loading: $props.loading,
              tight: ""
            }, {
              "bar-append": _withCtx(() => [_createVNode(_component_dot_element, {
                size: 6,
                color: "#E16098",
                style: {
                  "margin-left": "-3px",
                  "z-index": "1",
                  "align-self": "center"
                }
              })]),
              default: _withCtx(() => [_createVNode(_component_number_value, {
                value: row.item?.seller_notoriety,
                charCount: $options.maxCharCount?.number?.seller_notoriety,
                align: "right",
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(search_query_volume)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.search_query_volume,
              min: $options.minMax?.search_query_volume?.min,
              color: "#C1BDBD",
              max: $options.minMax?.search_query_volume?.max,
              loading: $props.loading,
              tight: ""
            }, {
              "bar-append": _withCtx(() => [_createVNode(_component_dot_element, {
                size: 6,
                color: "#9B9797",
                style: {
                  "margin-left": "-3px",
                  "z-index": "1",
                  "align-self": "center"
                }
              })]),
              default: _withCtx(() => [_createVNode(_component_number_value, {
                value: row.item?.search_query_volume,
                charCount: $options.maxCharCount?.number?.search_query_volume,
                align: "right",
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(search_revenue_share)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "4px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: "",
                tight: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.search_revenue_share,
              background: "",
              borderColor: "#FFE8DB",
              min: $options.minMax?.search_revenue_share?.min,
              max: $options.minMax?.search_revenue_share?.max,
              loading: $props.loading,
              align: "left",
              styles: {
                padding: 0
              },
              barStyles: {
                borderLeft: 'none',
                borderRadius: '4px',
                height: '20px',
                background: '#FFE8DB'
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_percentage_value, {
                value: row.item?.search_revenue_share,
                charCount: $options.maxCharCount?.percentage?.search_revenue_share,
                tight: ""
              }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
                value: row.item?.search_revenue,
                color: "#999",
                style: {
                  "font-size": "13px"
                }
              }, null, 8, ["value"])])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(impression_share)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: "",
                tight: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.seller_impression_share,
              background: "",
              borderColor: "#F2F4F8",
              min: 0,
              max: Math.max($options.minMax?.seller_click_share?.max, $options.minMax?.seller_impression_share?.max, $options.minMax?.seller_purchase_share?.max),
              loading: $props.loading,
              align: "left",
              styles: {
                padding: 0
              },
              barStyles: {
                borderLeft: 'none',
                borderRadius: '0px',
                height: '28px',
                background: '#F2F4F8'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_percentage_value, {
                value: row.item?.seller_impression_share,
                charCount: $options.minMax?.seller_impression_share?.min < 0.01 ? $options.maxCharCount?.percentage?.seller_impression_share + 2 : $options.maxCharCount?.percentage?.seller_impression_share + 1,
                precision: 1,
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(impression_count)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`seller_impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`seller_impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`seller_impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.seller_impression_count,
              min: $options.minMax?.seller_impression_count?.min,
              color: "#FEC9AA",
              max: $options.minMax?.seller_impression_count?.max,
              loading: $props.loading,
              tight: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_number_value, {
                value: row.item?.seller_impression_count,
                charCount: $options.maxCharCount?.number?.seller_impression_count,
                align: "right",
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(click_share)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_click_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: "",
                tight: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.seller_click_share,
              background: "",
              borderColor: "#F2F4F8",
              min: 0,
              max: Math.max($options.minMax?.seller_click_share?.max, $options.minMax?.seller_impression_share?.max, $options.minMax?.seller_purchase_share?.max),
              loading: $props.loading,
              align: "left",
              styles: {
                padding: 0
              },
              barStyles: {
                borderLeft: 'none',
                borderRadius: '0px',
                height: '28px',
                background: '#F2F4F8'
              },
              class: "click-share-bar"
            }, {
              default: _withCtx(() => [_createVNode(_component_percentage_value, {
                value: row.item?.seller_click_share,
                charCount: $options.minMax?.seller_purchase_share?.min < 0.01 ? $options.maxCharCount?.percentage?.seller_purchase_share + 2 : $options.maxCharCount?.percentage?.seller_purchase_share + 1,
                precision: 1,
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(click_count)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`seller_click_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`seller_click_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`seller_click_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.seller_click_count,
              min: $options.minMax?.seller_click_count?.min,
              color: "#FEC9AA",
              max: $options.minMax?.seller_click_count?.max,
              loading: $props.loading,
              tight: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_number_value, {
                value: row.item?.seller_click_count,
                charCount: $options.maxCharCount?.number?.seller_click_count,
                align: "right",
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(purchase_share)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: "",
                tight: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.seller_purchase_share,
              background: "",
              borderColor: "#F2F4F8",
              min: 0,
              max: Math.max($options.minMax?.seller_click_share?.max, $options.minMax?.seller_impression_share?.max, $options.minMax?.seller_purchase_share?.max),
              loading: $props.loading,
              align: "left",
              styles: {
                padding: 0
              },
              barStyles: {
                borderLeft: 'none',
                borderRadius: '0px',
                height: '28px',
                background: '#F2F4F8'
              },
              class: "purchase-share-bar"
            }, {
              default: _withCtx(() => [_createVNode(_component_percentage_value, {
                value: row.item?.seller_purchase_share,
                charCount: $options.minMax?.seller_purchase_share?.min < 0.01 ? $options.maxCharCount?.percentage?.seller_impression_share + 2 : $options.maxCharCount?.percentage?.seller_impression_share + 1,
                precision: 1,
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(purchase_count)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`seller_purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`seller_purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`seller_purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
                showSign: "",
                align: "right",
                tight: ""
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.seller_purchase_count,
              min: $options.minMax?.seller_purchase_count?.min,
              color: "#FEC9AA",
              max: $options.minMax?.seller_purchase_count?.max,
              loading: $props.loading,
              tight: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_number_value, {
                value: row.item?.seller_purchase_count,
                charCount: $options.maxCharCount?.number?.seller_purchase_count,
                align: "right",
                tight: ""
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(brand_ctr)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorsBasedOnRange(row.item?.ctr, $data.SEARCH_FUNNEL_CTR_HEATMAP_COLORS),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.ctr,
            precision: 1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        "cell(conversion_rate)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorsBasedOnRange(row.item?.seller_conversion_rate, $data.SEARCH_FUNNEL_CVR_HEATMAP_COLORS),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.seller_conversion_rate,
            precision: 1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked"])]),
      _: 1
    }, 8, ["modelValue", "period"])]),
    _: 3
  }, 8, ["fields", "loading"]);
}